import React from 'react';
import { useDispatch } from 'react-redux';
import { hideDialog } from 'store/modules/base/dialog';
import { updateSleepSettings } from 'store/modules/settings';
import { connect } from 'store/modules/base/redux';
import DigitalSignage from './DigitalSignage';
import PropTypes from 'prop-types';
import Filmstrip from 'util/UI/videolayout/Filmstrip';
import Box from '@mui/material/Box';
import withBoundary from 'component/ErrorBoundary/withBoundary';
const VWDigitalSignage = (props) => {
  const {
    clientHeight,
    filmstripVisible,
    options,
    showLeave = true,
    url
  } = props;
  const HEIGHT_OFFSET = 80;
  const dispatch = useDispatch();
  // const options = _userDevice?.browserOptions[0];
  const baseUrl = url
    ? url
    : options?.url
    ? options?.url
    : 'https://www.google.com/search?igu=1';

  const getDimensions = () => {
    let height;

    if (filmstripVisible) {
      height = clientHeight - Filmstrip.getFilmstripHeight();
    } else {
      height = clientHeight;
    }
    return {
      '@media (min-width: 800px)': {
        width: `85% !important`,
        height: `${height - HEIGHT_OFFSET}px !important`,
        marginLeft: `${HEIGHT_OFFSET}px`
      }
    };
  };
  const leaveSignage = () => {
    dispatch(hideDialog('DigitalSignage'));
    dispatch(
      updateSleepSettings({
        userDigitalSignageMode: false
      })
    );
  };
  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
      sx={options?.signageStyle === 'overlay' ? getDimensions() : {}}>
      <DigitalSignage
        baseUrl={baseUrl}
        onLeave={leaveSignage}
        showLeave={showLeave}
        style={{}}
        options={options}
      />
    </Box>
  );
};
/**
 * Maps (parts of) the Redux state to the associated LargeVideo props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
  return {
    clientWidth: state['features/base/responsive-ui'].clientWidth,
    clientHeight: state['features/base/responsive-ui'].clientHeight,
    filmstripVisible: state['features/filmstrip'].visible
  };
}
export default React.memo(
  connect(_mapStateToProps)(withBoundary(VWDigitalSignage))
);
VWDigitalSignage.propTypes = {
  filmstripVisible: PropTypes.bool,
  clientWidth: PropTypes.number,
  clientHeight: PropTypes.number,
  url: PropTypes.string,
  options: PropTypes.object,
  showLeave: PropTypes.bool
};
